// Set webpack public path
__webpack_public_path__ = document.head.querySelector('meta[name="base_assets"]').content

import {HadronCollider} from "@webreact/webreactor"

const router = new HadronCollider([
    {
        target: ".gform_wrapper",
        file: async () => (await import("./components/form")).default,
    }
])

router.run()